import React from "react";
import { connect } from "react-redux";
import {Link} from 'react-router-dom';

import "../../../css/forms/reviewer-registration-item.css";

import { formatMomentString } from "../../../utils/dateHelpers";

class PendingSection extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: 0
        };
    }

    componentDidMount() {
	}
    
    render(){
        const {fname, lname, email, phone, title, review_id, date} = this.props;
        const routeLink = "/admin/reviews/edit/" + review_id;
        const date_edited = formatMomentString(date, "MMMM D Y | hh:mm a");
        return(
            <React.Fragment>
            {this.state.isLoading ? 
            <div></div> : 
            <div>
                <div className="reviewer-container">
                    <div className="reviewer-registration--header"> 
                        <div className="reviewer-registration--headertitle">{title}</div>
                        <div className="reviewer-registration--headerdate">{date_edited}</div>
                    </div>
                    <div className="reviewer-registration-item">
                        <div className="reviewer-registration-item--reviewer">
                            <div className="reviewer-item--name">{fname} {lname}</div>
                            <div className="reviewer-item--email">{email}</div>
                            <div className="reviewer-item--phone">{phone}</div>
                        </div>
                        <div className="reviewer-registration-item--button">
                        <Link className="btn submit-btn" to={routeLink}>Take Action</Link>
                        </div>
                    </div>
                </div>
            </div>
            }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
});

export default connect(
	mapStateToProps,
	{
	}
)(PendingSection);


// WEBPACK FOOTER //
// ./src/components/admin/pending/PendingSection.js